import { render, staticRenderFns } from "./Conveniados.vue?vue&type=template&id=eb915820&"
import script from "./Conveniados.vue?vue&type=script&lang=js&"
export * from "./Conveniados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports